import { Controller } from '@hotwired/stimulus';

const FILTER_MAPPER = {
  all: ['current', 'terminated'],
  current: ['current'],
  terminated: ['terminated']
};

export default class extends Controller {
  static targets = ['row', 'select', 'noResults'];

  connect() {
    if (this.hasSelectTarget) {
      this.selectTarget.value = 'current';
    }
    this.filter();
  }

  filter() {
    const value = this.selectTarget.value;
    const allowedStates = FILTER_MAPPER[value];

    let visibleRows = 0;

    this.rowTargets.forEach((row) => {
      const state = row.dataset.policyState;
      const visible = allowedStates.includes(state);
      row.style.display = visible ? '' : 'none';

      if (visible) visibleRows += 1;
    });

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.style.display = visibleRows > 0 ? 'none' : '';
    }
  }
}
